/**
 * useDashboardRange — Zeitraum lebt in der URL (?zeitraum=30d&von=&bis=),
 * damit gefilterte Ansichten teilbar sind und ein Reload sie behält.
 */
import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { resolveRange } from '@/lib/dashboardAnalytics';

export function useDashboardRange() {
  const [params, setParams] = useSearchParams();
  const preset = params.get('zeitraum') || '30d';
  const from = params.get('von') || '';
  const to = params.get('bis') || '';

  const range = useMemo(() => resolveRange({ preset, from, to }), [preset, from, to]);

  const update = useCallback((next) => {
    setParams((prev) => {
      const p = new URLSearchParams(prev);
      p.set('zeitraum', next.preset);
      if (next.preset === 'custom') {
        p.set('von', next.from ?? from);
        p.set('bis', next.to ?? to);
      } else {
        p.delete('von');
        p.delete('bis');
      }
      return p;
    }, { replace: true });
  }, [setParams, from, to]);

  return { range, preset: range.preset, rawFrom: from, rawTo: to, update };
}
